import { styled } from 'styled-components';

export const OtpInputWrapper = styled.div`
  max-width: ${({ $width }) => ($width ? $width : '100%')};
  margin: 0 auto 20px;

  .otp-fields {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 20px;

    @media (min-width: 576px) {
      gap: 20px;
    }
  }

  input {
    width: 100%;
    max-width: ${({ $inputWidth }) => ($inputWidth ? $inputWidth : '90px')};
    height: 60px;
    border: 1px solid transparent;
    background: ${({ $inputBg }) => ($inputBg ? $inputBg : 'var(--gray-100)')};
    border-radius: 10px;
    padding: 10px;
    font-size: 28px;
    line-height: 32px;
    box-sizing: border-box;
    outline: none;
    text-align: center;
    border: 1px solid rgba(157, 157, 157, 0.2);

    @media (max-width: 576px) {
      height: 50px;
      padding: 10px 10px 5px;
      font-size: 20px;
      line-height: 24px;
    }

    &::placeholder {
      font-size: 35px;
      line-height: 20px;
      color: #777777;
    }
    &:focus {
      border: 1px solid ${({ theme }) => theme?.light?.primary};
    }
  }

  input:focus::placeholder {
    color: transparent;
  }

  .timer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    line-height: 19px;
    font-weight: 400;

    .resend-code {
      color: var(--primary);
      cursor: pointer;
      font-weight: 700;
    }
  }
`;
export const StyledSignUp = styled.div`
  width: 100%;

  .login-body {
    margin-bottom: 20px;
    .two-col {
      display: grid;
      grid-template-columns: 1fr;
      row-gap: 6px;

      @media (min-width: 768px) {
        column-gap: 15px;
        grid-template-columns: 1fr 1fr;
      }
    }
    .termsCondition {
      color: var(--gray);
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
      a {
        color: var(--primary);
      }
    }
    .btn-wrap {
      width: 100%;
      text-align: right;
    }
    .forgot_password {
      margin-left: auto;
      margin-bottom: 15px;
      font-size: 14px;
      font-weight: 400;
      line-height: 17px;
      outline: none;
      border: none;
      text-decoration: underline;
    }
  }
  .login-footer {
    width: 100%;
    text-align: center;

    .footerText {
      width: 100%;
      font-size: 16px;
      font-weight: 300;
      line-height: 19.76px;
      text-align: center;

      button {
        outline: none;
        border: none;
        text-decoration: underline;
      }
    }
  }
`;
